export default "__VITE_ASSET__bYyDtNVtqrUt5WsHoI2TfQ__"